import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_HttpTimeout3mcrbvfnvmyx2 as get_HttpTimeout } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/HttpTimeout.mjs';
import { setReadTimeout12jih49pjfudm as setReadTimeout } from './KtorHttpEngine.js.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
} from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { Companion_getInstance13wwf84j92s7c as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { header3kx6g3yb4df1r as header } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/utils.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance3jaj4elqoxne0 as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../../../../ktor-ktor-client-core/io/ktor/client/statement/HttpStatement.mjs';
import { isByteArray4nnzfn1x4o3w as isByteArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Builder1mo34du82b3c6 as Builder,
  HttpHeader1d7ldebjomr00 as HttpHeader,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { flattenEntries2zw7fl55k6a0l as flattenEntries } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  disposehycj9shx8d5q as dispose,
  HttpEngine345320iy1heif as HttpEngine,
} from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/network/http/HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KtorHttpEngineClass;
function KtorHttpEngine() {
  if (KtorHttpEngineClass === VOID) {
    class $ {
      static f6f(client) {
        var $this = createThis(this);
        $this.d6f_1 = client;
        $this.e6f_1 = false;
        return $this;
      }
      static l6f(timeoutMillis) {
        timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
        return this.m6f(timeoutMillis, timeoutMillis);
      }
      static m6f(connectTimeoutMillis, readTimeoutMillis) {
        return this.f6f(HttpClient(($this$HttpClient) => {
          $this$HttpClient.w5i_1 = false;
          var tmp = get_HttpTimeout();
          $this$HttpClient.w5j(tmp, ($this$install) => {
            $this$install.t5v(connectTimeoutMillis);
            setReadTimeout($this$install, readTimeoutMillis);
            return Unit_instance;
          });
          return Unit_instance;
        }));
      }
      *o69(request, $completion) {
        try {
          var tmp0 = this.d6f_1;
          // Inline function 'io.ktor.client.request.request' call
          var urlString = request.g4a_1;
          // Inline function 'io.ktor.client.request.request' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (HttpRequestBuilder())();
          url(this_0, urlString);
          var tmp = this_0;
          var tmp_0;
          switch (request.f4a_1.w1_1) {
            case 0:
              tmp_0 = Companion_getInstance().z51_1;
              break;
            case 1:
              tmp_0 = Companion_getInstance().a52_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp.o5j_1 = tmp_0;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = request.h4a_1.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            header(this_0, element.t49_1, element.u49_1);
          }
          var tmp1_safe_receiver = request.i4a_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            header(this_0, 'Content-Type', tmp1_safe_receiver.h48());
            var buffer = new (Buffer())();
            tmp1_safe_receiver.k48(buffer);
            // Inline function 'io.ktor.client.request.setBody' call
            var body = buffer.e3z();
            if (body == null) {
              this_0.q5j_1 = NullBody_instance;
              // Inline function 'io.ktor.util.reflect.typeInfo' call
              var tmp_1 = PrimitiveClasses_getInstance().zf();
              // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
              var tmp_2;
              try {
                tmp_2 = createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), false);
              } catch ($p) {
                var tmp_3;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_3 = null;
                } else {
                  throw $p;
                }
                tmp_2 = tmp_3;
              }
              var tmp$ret$11 = tmp_2;
              var tmp$ret$10 = new (TypeInfo())(tmp_1, tmp$ret$11);
              this_0.j5n(tmp$ret$10);
            } else {
              if (body instanceof OutgoingContent()) {
                this_0.q5j_1 = body;
                this_0.j5n(null);
              } else {
                this_0.q5j_1 = body;
                // Inline function 'io.ktor.util.reflect.typeInfo' call
                var tmp_4 = PrimitiveClasses_getInstance().zf();
                // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
                var tmp_5;
                try {
                  tmp_5 = createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), false);
                } catch ($p) {
                  var tmp_6;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_6 = null;
                  } else {
                    throw $p;
                  }
                  tmp_5 = tmp_6;
                }
                var tmp$ret$13 = tmp_5;
                var tmp$ret$12 = new (TypeInfo())(tmp_4, tmp$ret$13);
                this_0.j5n(tmp$ret$12);
              }
            }
          }
          // Inline function 'io.ktor.client.request.request' call
          var response = yield* (new (HttpStatement())(this_0, tmp0)).t60($completion);
          // Inline function 'io.ktor.client.call.body' call
          var tmp_7 = response.l5k();
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_8 = PrimitiveClasses_getInstance().dg();
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_9;
          try {
            tmp_9 = createKType(PrimitiveClasses_getInstance().dg(), arrayOf([]), false);
          } catch ($p) {
            var tmp_10;
            if ($p instanceof Error) {
              var _unused_var__etf5q3_1 = $p;
              tmp_10 = null;
            } else {
              throw $p;
            }
            tmp_9 = tmp_10;
          }
          var tmp$ret$17 = tmp_9;
          var tmp$ret$16 = new (TypeInfo())(tmp_8, tmp$ret$17);
          var tmp_11 = yield* tmp_7.i5k(tmp$ret$16, $completion);
          var responseByteArray = (!(tmp_11 == null) ? isByteArray(tmp_11) : false) ? tmp_11 : THROW_CCE();
          var responseBufferedSource = (new (Buffer())()).r3z(responseByteArray);
          var tmp_12 = (new (Builder())(response.u5k().w54_1)).z49(responseBufferedSource);
          // Inline function 'kotlin.collections.map' call
          var this_1 = flattenEntries(response.y51());
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().h2(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var item = _iterator__ex2g4s_0.r1();
            var tmp$ret$20 = new (HttpHeader())(item.ue_1, item.ve_1);
            destination.i2(tmp$ret$20);
          }
          return tmp_12.l49(destination).c38();
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Error) {
              var t = $p;
              throw ApolloNetworkException().e48(t.message, t);
            } else {
              throw $p;
            }
          }
        }
      }
      l6() {
        if (!this.e6f_1) {
          this.d6f_1.l6();
          this.e6f_1 = true;
        }
      }
    }
    protoOf($).uz = dispose;
    initMetadataForClass($, 'KtorHttpEngine', $.l6f, VOID, [HttpEngine()], [1]);
    KtorHttpEngineClass = $;
  }
  return KtorHttpEngineClass;
}
//region block: exports
export {
  KtorHttpEngine as KtorHttpEngine1d787w9ug90jw,
};
//endregion

//# sourceMappingURL=KtorHttpEngine.mjs.map
